import React from 'react';

// Styles & Assets
import styles from './NoteCell.module.css';

interface Props{
    children: React.ReactNode
    pos?: {
        left?: number,
        top?: number,
        right?: number,
        bottom?: number,
    }
}
const NoteCell: React.FC<Props> = ({ children, pos }) => {

    return (
        <div className={styles.noteContainer} style={{left: pos?.left + 'px', top: pos?.top + 'px', right: pos?.right + 'px', bottom: pos?.bottom + 'px'}}>
            {children}
        </div>
    );
};

export default NoteCell;